import { FormattedMessage } from "react-intl";
import { useTitle } from "../components/Layout.js";

// Zástupná stránka obchodních podmínek a ochrany osobních údajů, dokud nejsou texty od právníka
// (REQ-017, Libor 16. 10. 2026).
export function LegalPage() {
  useTitle(undefined);
  return (
    <div className="stack">
      <h1>
        <FormattedMessage id="legal.title" />
      </h1>
      <p className="muted">
        <FormattedMessage id="legal.body" />
      </p>
    </div>
  );
}
